import { apiGet, apiPost } from '@ibkr/clientportal.common/src/api/default'
import { protectProd } from '@ibkr/clientportal.common/src/store/getters'

const base = process.env.BASE_IA_URL || '';
const iaAgreementsUrl = process.env.IA_AGREEMENTS || '';
const iaPartitionSignUp = process.env.IA_PARTITION_SIGNUP || '';

function getAdvisorsPromoData(iaPartner) {
    return apiGet(`${base}?partner=${iaPartner}`);
}

function getAdvisorsAgreementsData(iaPartner) {
    return apiGet(`${iaAgreementsUrl}?partner=${iaPartner}`);
}

function startPartitionSignUp(agreements, iaPartner) {
    return apiPost(`${iaPartitionSignUp}?partner=${iaPartner}`, { "agreements": agreements });
}

export default {
    getAdvisorsPromoData,
    getAdvisorsAgreementsData,
    startPartitionSignUp
}